import { PolicyPropertiesTab } from "~/pages/shared/policy/tabs/PolicyPropertiesTab";

export function PlatformPolicyPropertiesTab() {
  return <PolicyPropertiesTab />;
}
